import React from 'react';
import VisibilityIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOffRounded';
import { FormControl, InputLabel, Input, InputAdornment, IconButton } from '@mui/material';


class PasswordTextField extends React.Component {
    state = {
        showPassword: false,
    }

    render() {
        const { classes, labelText, required, ...other } = this.props;

        return (
            <FormControl variant="standard" fullWidth required={required}>
                <InputLabel htmlFor='adornment-password'>{labelText}</InputLabel>
                <Input
                    type={this.state.showPassword ? 'text' : 'password'}
                    endAdornment={
                        <InputAdornment position='end'>
                            <IconButton
                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                                size="large"
                            >
                                {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }
                    {...other}
                />
            </FormControl>
        );
    }
}

export default PasswordTextField;